import { getArrayOfEmails } from 'utils';
import { AddGroupForm, MainGroupInfoForm } from './BulkAddMember.component';

export const getMainGroupInfoPayloadValues = (values: MainGroupInfoForm) => {
  const {
    name,
    buySideGroupMembers: buySideGroupMembersSubmitted,
    buySideGroupMembersUnsubmited,
  } = values;

  const buySideGroupMembers = getArrayOfEmails(
    buySideGroupMembersSubmitted,
    buySideGroupMembersUnsubmited,
  );

  return {
    name,
    ...(buySideGroupMembers.length && { buySideGroupMembers }),
  };
};

export const getAddGroupPayloadValues = (values: AddGroupForm) => {
  const { grantFullAccess } = values;

  return {
    ...getMainGroupInfoPayloadValues(values),
    grantFullAccess: !!grantFullAccess,
  };
};
